import React, { Component } from 'react'
import { connect } from 'react-redux'
import actions from '../../actions/index'
import { Card, CardHeader, CardBody } from '../Card'
import SavedSearchPaddleRow from './SavedSearchPaddleRow'
import Collapsible from '../Collapsible'

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

class SavedSearchPaddle extends Component {
  constructor(props) {
    super(props);
    this.collapsible = React.createRef()
  }

  componentDidMount() {
    if (this.props.user) {
      this.props.onFetch().then(() => {
        if (this.props.userSearches.savedSearches.length == 0) {
          this.collapsible.current.togglePanel()
        }
      })
    }
  }

  updateUserSearches = (updatedSavedSearches) => {
    const request = () => {
      return {
        ...this.props.userSearches,
        savedSearches: updatedSavedSearches
      }
    }
    this.props.onSubmit(request())
    this.props.userSearches.savedSearches = updatedSavedSearches
  }

  render() {
    const ShowSavedSearches = ({ apiData }) => (
      <>
        {apiData.savedSearches.sort((a, b) => a.name.localeCompare(b.name))
          .map((savedSearch, index) => (
            <SavedSearchPaddleRow
              key={savedSearch.id}
              id={savedSearch.id}
              name={savedSearch.name}
              url={savedSearch.url}
              savedSearchAlert={savedSearch.savedSearchAlert}
              savedSearchAlertTime={savedSearch.savedSearchAlertTime}
              savedSearchInstantAlert={savedSearch.savedSearchInstantAlert}
              userSearches={apiData}
              apiCallFunc={this.updateUserSearches}
            />
          ))}
      </>
    )

    return (
      <div className={'paddle saved_search_paddle ' + (this.props.userSearches.savedSearches.length > 0 ? ' alert_enabled' : ' alert_disabled')} >
        <Card>
          <Collapsible ref={this.collapsible} title='Saved Searches and Alerts' titleClassName='paddle_name'>
            <CardBody>
              <div className='card_body_row'>
                <div>
                  <span className='category_text'>
                    Click on the name of the saved search below to view the most recent results.
                    If you enable alerts, you will receive a daily email containing headlines and
                    summaries of all articles published that match your search criteria, at the time you choose.
                    Add a new saved search to this list by saving your search results.
                  </span>
                </div>
              </div>
              <ShowSavedSearches id='userSearches' apiData={this.props.userSearches}></ShowSavedSearches>
            </CardBody>
          </Collapsible>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    userSearches: state.userSearches
  }
}

const mapDispatchToProps = (dispatch) => ({
  onFetch: () => new Promise((resolve, reject) => {
    dispatch(actions.fetchSavedSearches()).then(() => {
      resolve();
    })
  }),

  onSubmit: (request) => new Promise((resolve, reject) => {
    dispatch(actions.updateSavedSearches(request)).then(() => {
      resolve();
    })
  })
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SavedSearchPaddle)
